import React from "react";
import ReactDOM from "react-dom/client";

import { ProductMoreColors } from "@app/scripts/react-product-more-colors/components/ProductMoreColors";
import { ProductMoreColorsPlpConvert } from "@app/scripts/react-product-more-colors/components/ProductMoreColorsPlp";

import type { Product } from "@app/scripts/types";

const ProductMoreColorsElem = class extends HTMLElement {
  static observedAttributes = ["product", "mode"];

  connectedCallback() {
    let product: Product | null = null;
    const mode = this.getAttribute("mode") || "pdp";

    try {
      const data = this.querySelector("[data-json]");
      if (!data) {
        throw Error("No product json found.");
      }
      product = JSON.parse(data.innerHTML);
    } catch (error) {
      console.error(error);
    }

    const root = ReactDOM.createRoot(this);
    root.render(
      mode === "plp" ? (
        <ProductMoreColorsPlpConvert product={product as Product} />
      ) : (
        <ProductMoreColors product={product as Product} />
      )
    );
  }
};

customElements.define("product-more-colors", ProductMoreColorsElem);
